import {FC, useEffect, useState} from 'react'
import {PromoBannerCard} from './components/PromoBannerCard'
import {
  createPromoBanner,
  deletePromoBanner,
  listPromoBanners,
  updatePromoBanner,
} from './promoBannerService'
import {PromoBanner, PromoBannerFormValues} from './types'

export const PromoBannersAdminPage: FC = () => {
  const [banners, setBanners] = useState<PromoBanner[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [savingId, setSavingId] = useState<number | 'new' | null>(null)

  const loadBanners = async () => {
    setLoading(true)
    try {
      const data = await listPromoBanners()
      setBanners(data)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadBanners()
  }, [])

  const handleSave = async (values: PromoBannerFormValues, id?: number) => {
    setSavingId(id ?? 'new')
    try {
      const result = id
        ? await updatePromoBanner(id, values)
        : await createPromoBanner(values)
      if (result) {
        await loadBanners()
      }
    } finally {
      setSavingId(null)
    }
  }

  const handleDelete = async (id: number) => {
    // Confirmation now lives in PromoBannerCard via <ConfirmDialog/>; this
    // handler is only reached after the user clicks Accept in the dialog.
    const ok = await deletePromoBanner(id)
    if (ok) await loadBanners()
  }

  const nextPosition = banners.length
    ? Math.max(...banners.map((b) => b.position)) + 1
    : 1

  return (
    <div style={{padding: '32px 40px'}}>
      <div
        style={{
          background: '#ffffff',
          border: '1px solid #e9e9e9',
          borderRadius: 8,
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
          padding: '32px 40px',
        }}
      >
        <div
          className='d-flex align-items-baseline justify-content-between'
          style={{marginBottom: 24, paddingBottom: 16, borderBottom: '1px solid #e9e9e9'}}
        >
          <h1
            style={{
              fontFamily: 'Oswald, sans-serif',
              fontWeight: 500,
              fontSize: 28,
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              color: '#151515',
              margin: 0,
            }}
          >
            Dashboard promo banners
          </h1>
        </div>

      {loading && (
        <div style={{padding: 24, textAlign: 'center', color: '#6b6b6b'}}>Loading...</div>
      )}

      {!loading &&
        banners.map((banner) => (
          <PromoBannerCard
            key={banner.id}
            slotLabel={`Banner #${banner.id}`}
            initial={banner}
            saving={savingId === banner.id}
            onSave={handleSave}
            onDelete={handleDelete}
          />
        ))}

      <div style={{marginTop: 32}}>
        <h2
          style={{
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 500,
            fontSize: 18,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: '#151515',
            marginBottom: 12,
          }}
        >
          Create new banner
        </h2>
        <PromoBannerCard
          slotLabel='New banner'
          initial={
            {
              id: 0,
              image: '',
              link: '',
              alt_text: '',
              style: 'bordered',
              position: nextPosition,
              is_active: true,
            } as PromoBanner
          }
          saving={savingId === 'new'}
          onSave={(values) => handleSave({...values, id: undefined})}
        />
      </div>
      </div>
    </div>
  )
}
